import { render, staticRenderFns } from "./AllBusinessNameDataUpdateSubmissions.vue?vue&type=template&id=ddef5c58&scoped=true&"
import script from "./AllBusinessNameDataUpdateSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllBusinessNameDataUpdateSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllBusinessNameDataUpdateSubmissions.vue?vue&type=style&index=0&id=ddef5c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddef5c58",
  null
  
)

export default component.exports